// Kapı/Pencere Mock Data
// Kapı ve pencere siparişleri, ölçü ve montaj takibi

export const kapiPencereMalzemeler = [
    {
        id: 'kp-001',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-01-15',
        tedarikci: 'Egepen Deceuninck',
        tedarikciFirmaId: 'f-100',
        kategori: 'pencere',
        urunAdi: 'PVC Pencere',
        aciklama: '120x150 Çift Cam',
        malzeme: 'PVC',
        renk: 'Beyaz',
        ebat: '120x150 cm',
        miktar: 80,
        birim: 'adet',
        birimFiyat: 4500,
        toplamFiyat: 360000,
        durum: 'teslim',
        stokMiktar: 20,
        montajlanan: 60,
        montajDurumu: 'devam',
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        not: '15 daire montajı tamamlandı',
        createdAt: '2026-01-05T10:00:00Z',
        updatedAt: '2026-01-17T16:00:00Z',
    },
    {
        id: 'kp-002',
        siparisTarihi: '2026-01-05',
        teslimTarihi: '2026-01-15',
        tedarikci: 'Egepen Deceuninck',
        tedarikciFirmaId: 'f-100',
        kategori: 'kapi',
        urunAdi: 'PVC Balkon Kapısı',
        aciklama: '70x220 Çift Cam',
        malzeme: 'PVC',
        renk: 'Beyaz',
        ebat: '70x220 cm',
        miktar: 40,
        birim: 'adet',
        birimFiyat: 5500,
        toplamFiyat: 220000,
        durum: 'teslim',
        stokMiktar: 10,
        montajlanan: 30,
        montajDurumu: 'devam',
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        not: 'Balkon kapıları',
        createdAt: '2026-01-05T10:00:00Z',
        updatedAt: '2026-01-17T16:00:00Z',
    },
    {
        id: 'kp-003',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-18',
        tedarikci: 'StarDoor',
        tedarikciFirmaId: 'f-101',
        kategori: 'ic-kapi',
        urunAdi: 'Amerikan Panel Kapı',
        aciklama: '87x205 Amerikan Panel Beyaz',
        malzeme: 'MDF Kaplama',
        renk: 'Beyaz',
        ebat: '87x205 cm',
        miktar: 100,
        birim: 'adet',
        birimFiyat: 2800,
        toplamFiyat: 280000,
        durum: 'teslim',
        stokMiktar: 40,
        montajlanan: 60,
        montajDurumu: 'devam',
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        not: 'İç kapılar',
        createdAt: '2026-01-08T09:00:00Z',
        updatedAt: '2026-01-18T14:00:00Z',
    },
    {
        id: 'kp-004',
        siparisTarihi: '2026-01-10',
        teslimTarihi: null,
        tedarikci: 'Çelik Kapı A.Ş.',
        tedarikciFirmaId: 'f-102',
        kategori: 'celik-kapi',
        urunAdi: 'Çelik Kapı Lüks',
        aciklama: '90x205 Özel Tasarım',
        malzeme: 'Çelik',
        renk: 'Ceviz',
        ebat: '90x205 cm',
        miktar: 20,
        birim: 'adet',
        birimFiyat: 12000,
        toplamFiyat: 240000,
        durum: 'bekliyor',
        stokMiktar: 0,
        montajlanan: 0,
        montajDurumu: 'bekliyor',
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        not: 'Daire giriş kapıları',
        createdAt: '2026-01-10T11:00:00Z',
        updatedAt: '2026-01-10T11:00:00Z',
    },
];

// Kapı/Pencere kategorileri
export const kapiPencereKategorileri = [
    { key: 'pencere', label: 'Pencere', icon: '🪟' },
    { key: 'kapi', label: 'Balkon Kapısı', icon: '🚪' },
    { key: 'ic-kapi', label: 'İç Kapı', icon: '🚪' },
    { key: 'celik-kapi', label: 'Çelik Kapı', icon: '🔐' },
];

// Montaj durumları
export const montajDurumlari = [
    { key: 'bekliyor', label: 'Bekliyor', color: 'info' },
    { key: 'devam', label: 'Devam Ediyor', color: 'warning' },
    { key: 'tamamlandi', label: 'Tamamlandı', color: 'success' },
];

// İstatistikler
export const getKapiPencereStats = (insaatId) => {
    const filtered = insaatId
        ? kapiPencereMalzemeler.filter(s => s.insaatId === insaatId)
        : kapiPencereMalzemeler;

    const toplamAdet = filtered.reduce((acc, s) => acc + s.miktar, 0);
    const montajlanan = filtered.reduce((acc, s) => acc + s.montajlanan, 0);
    const bekleyen = filtered.filter(s => s.durum === 'bekliyor').reduce((acc, s) => acc + s.miktar, 0);
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);

    return {
        toplamAdet,
        montajlanan,
        bekleyen,
        toplamMaliyet,
        montajOrani: toplamAdet > 0 ? Math.round((montajlanan / toplamAdet) * 100) : 0,
    };
};

// Helper: insaata göre filtrele
export const getKapiPencereByInsaat = (insaatId) => {
    if (!insaatId) return kapiPencereMalzemeler;
    return kapiPencereMalzemeler.filter(s => s.insaatId === insaatId);
};
